<script lang="ts">
  import { getContext } from 'svelte';
  import clsx from 'clsx';
  import { type TabsContext, type TabProps, tabsContextKey } from './types';
  let elementRef: HTMLButtonElement | undefined = $state(undefined);

  const { children }: TabProps = $props();
  const context = getContext<TabsContext>(tabsContextKey);
  const tabNumber = ++context.renderedTabs;

  $effect(() => {
    if (elementRef && tabNumber === context.activeTab() && context.previousTab() !== undefined) {
      elementRef.focus();
    }
  });
</script>

<div>
  <button
    type="button"
    bind:this={elementRef}
    onclick={() => context.setActiveTab(tabNumber)}
    class={clsx(
      'relative border-b-[5px] border-solid pb-4 text-lg',
      tabNumber !== context.activeTab() && 'top-[6px] border-transparent',
      tabNumber === context.activeTab() && 'top-[6px] border-st-black pb-2 font-semibold ',
    )}
    role="tab"
    tabindex={tabNumber === context.activeTab() ? 0 : -1}
    aria-selected={tabNumber === context.activeTab()}
    aria-controls={context.panelId(tabNumber)}
    id={context.tabId(tabNumber)}
  >
    {@render children()}
  </button>
</div>
